import { NgModule } from '@angular/core';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';

@NgModule({
  imports: [GameButtonComponent],
  exports: [GameButtonComponent],
})
export class GamesMaterialPackModule {}
